import { h } from 'preact'
import { useMemo } from 'preact/hooks'

import { TITLES } from '../../config'
import { buildCategoryPermalink } from '../../utils/urls'
import BackgroundTitle from '../atom/BackgroundTitle'
import MonthList from '../atom/MonthList'
import { SimpleList, SimpleListEntry } from '../atom/SimpleList'
import NodeList from '../molecule/NodeList'
import { SiteContentEntry } from '../molecule/SiteContent'
import TagCloud from '../molecule/TagCloud'
import { SiteFooterEntry } from '../organism/SiteFooter'
import { formatDateParts } from '../../date/format'

const Archive = ({ posts = [] }) => {
  const entries = useMemo(
    () => buildEntries(posts),
    [posts],
  )

  return (
    <SiteContentEntry>
      <BackgroundTitle>{TITLES.ARCHIVES}</BackgroundTitle>

      <SimpleList>
        {entries.map(props => (
          <SimpleListEntry key={props.year}>
            <MonthList {...props} />
          </SimpleListEntry>
        ))}
      </SimpleList>
    </SiteContentEntry>
  )
}

export const ArchiveFooter = ({ categories, tags }) => (
  <>
    <ArchiveFooterCategories categories={categories} />
    <ArchiveFooterTags tags={tags} />
  </>
)

export const ArchiveFooterCategories = ({ categories = [] }) => {
  if (!categories.length) {
    return null
  }

  return (
    <SiteFooterEntry>
      <BackgroundTitle small light>
        {TITLES.CATEGORIES}
      </BackgroundTitle>

      <NodeList
        entries={categories}
        uriBuilder={buildCategoryPermalink}
      />
    </SiteFooterEntry>
  )
}

export const ArchiveFooterTags = ({ tags = [] }) => {
  if (!tags.length) {
    return null
  }

  return (
    <SiteFooterEntry>
      <BackgroundTitle small light>
        {TITLES.TAGS}
      </BackgroundTitle>

      <TagCloud entries={tags} />
    </SiteFooterEntry>
  )
}

function buildEntries(entries = []) {
  const result = entries.map(yearEntry => {
    const { year, months = [] } = yearEntry

    return {
      year,
      key: yearEntry.id,
      title: formatDateParts({ year }).year,
      href: yearEntry.href,
      entries: months.map(monthEntry => ({
        key: monthEntry.id,
        label: formatDateParts(monthEntry).month,
        month: monthEntry.month,
        href: monthEntry.total !== 0 && monthEntry.href,
        title: monthEntry.total !== 0 && buildMonthTitle(monthEntry.total),
        total: monthEntry.total,
      })),
    }
  })

  return result
    .sort((a, b) => b.year - a.year)
    .map(cleanupMonthList)
}

function buildMonthTitle(count) {
  return count === 1 ? `1 post` : `${count} posts`
}

function cleanupMonthList(year, idx, arr) {
  if (idx === 0) {
    year.entries = filterStart(year.entries)
  }

  if (idx === arr.length - 1) {
    year.entries = filterStart(year.entries.reverse()).reverse()
  }

  return year
}

function filterStart(entries) {
  const idx = entries.findIndex((entry) => entry.total > 0)

  return idx === -1 ? entries : entries.slice(idx)
}

export default Archive
